export default {"src":"/_next/static/media/joinTopFrame.dfe6454e.svg","height":310,"width":1920,"blurWidth":0,"blurHeight":0};